 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"change-password":"change-password","configurations-categories":"configurations-categories","configurations-jornal":"configurations-jornal","configurations-roles":"configurations-roles","configurations-sectors":"configurations-sectors","configurations-subcontractors":"configurations-subcontractors","configurations-users":"configurations-users","configurations-workers":"configurations-workers","confirm-email":"confirm-email","login":"login","planning-compliance":"planning-compliance","planning-dashboard~plans-2d~plans-3d~work-profile":"planning-dashboard~plans-2d~plans-3d~work-profile","planning-dashboard~tasker-report~work-profile":"planning-dashboard~tasker-report~work-profile","planning-dashboard~tasker-report":"planning-dashboard~tasker-report","planning-dashboard":"planning-dashboard","work-profile":"work-profile","plans-2d~plans-3d":"plans-2d~plans-3d","plans-2d":"plans-2d","plans-3d":"plans-3d","planning-report~productivity-report~tasker-report":"planning-report~productivity-report~tasker-report","productivity-report~tasker-report":"productivity-report~tasker-report","tasker-report":"tasker-report","planning-report":"planning-report","productivity-report":"productivity-report","planning-restrictions":"planning-restrictions","productivity-advances":"productivity-advances","tasker-departures":"tasker-departures","tasker-groups":"tasker-groups","users":"users","welcome":"welcome"}[chunkId]||chunkId) + "." + {"change-password":"ac34cb04","configurations-categories":"c981cfd3","configurations-jornal":"623d2386","configurations-roles":"bf2b4408","configurations-sectors":"d972e906","configurations-subcontractors":"84f696cd","configurations-users":"b6935d0b","configurations-workers":"3e9767f3","confirm-email":"41612fab","login":"280e1f99","planning-compliance":"4999e4ba","planning-dashboard~plans-2d~plans-3d~work-profile":"b7b74eba","planning-dashboard~tasker-report~work-profile":"52164f5d","planning-dashboard~tasker-report":"739eaa52","planning-dashboard":"e611191e","work-profile":"6a385a22","plans-2d~plans-3d":"6757e4eb","plans-2d":"af50f4fd","plans-3d":"e9082d01","planning-report~productivity-report~tasker-report":"28910de0","productivity-report~tasker-report":"781a857d","tasker-report":"7c29d2fc","planning-report":"30c05ff4","productivity-report":"dbd266b2","planning-restrictions":"13078201","productivity-advances":"670621b1","tasker-departures":"fe2cab8c","tasker-groups":"e9a6dbe1","users":"9c134b90","welcome":"ae385cc6","chunk-2d0ab8b7":"30a5379a","chunk-2d208699":"71c944f4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"confirm-email":1,"login":1,"planning-dashboard":1,"productivity-report~tasker-report":1,"tasker-report":1,"productivity-report":1,"tasker-departures":1,"users":1,"welcome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"change-password":"change-password","configurations-categories":"configurations-categories","configurations-jornal":"configurations-jornal","configurations-roles":"configurations-roles","configurations-sectors":"configurations-sectors","configurations-subcontractors":"configurations-subcontractors","configurations-users":"configurations-users","configurations-workers":"configurations-workers","confirm-email":"confirm-email","login":"login","planning-compliance":"planning-compliance","planning-dashboard~plans-2d~plans-3d~work-profile":"planning-dashboard~plans-2d~plans-3d~work-profile","planning-dashboard~tasker-report~work-profile":"planning-dashboard~tasker-report~work-profile","planning-dashboard~tasker-report":"planning-dashboard~tasker-report","planning-dashboard":"planning-dashboard","work-profile":"work-profile","plans-2d~plans-3d":"plans-2d~plans-3d","plans-2d":"plans-2d","plans-3d":"plans-3d","planning-report~productivity-report~tasker-report":"planning-report~productivity-report~tasker-report","productivity-report~tasker-report":"productivity-report~tasker-report","tasker-report":"tasker-report","planning-report":"planning-report","productivity-report":"productivity-report","planning-restrictions":"planning-restrictions","productivity-advances":"productivity-advances","tasker-departures":"tasker-departures","tasker-groups":"tasker-groups","users":"users","welcome":"welcome"}[chunkId]||chunkId) + "." + {"change-password":"31d6cfe0","configurations-categories":"31d6cfe0","configurations-jornal":"31d6cfe0","configurations-roles":"31d6cfe0","configurations-sectors":"31d6cfe0","configurations-subcontractors":"31d6cfe0","configurations-users":"31d6cfe0","configurations-workers":"31d6cfe0","confirm-email":"e7a7edfe","login":"e7a7edfe","planning-compliance":"31d6cfe0","planning-dashboard~plans-2d~plans-3d~work-profile":"31d6cfe0","planning-dashboard~tasker-report~work-profile":"31d6cfe0","planning-dashboard~tasker-report":"31d6cfe0","planning-dashboard":"2ca328e8","work-profile":"31d6cfe0","plans-2d~plans-3d":"31d6cfe0","plans-2d":"31d6cfe0","plans-3d":"31d6cfe0","planning-report~productivity-report~tasker-report":"31d6cfe0","productivity-report~tasker-report":"47beadd4","tasker-report":"be2d3461","planning-report":"31d6cfe0","productivity-report":"532e34be","planning-restrictions":"31d6cfe0","productivity-advances":"31d6cfe0","tasker-departures":"aba0bc34","tasker-groups":"31d6cfe0","users":"e4867cf5","welcome":"a779d6b9","chunk-2d0ab8b7":"31d6cfe0","chunk-2d208699":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
